/**
 * `cate_list.link.href`의 값이 `?cate_list_id=$`의 형태라서 만든 함수
 * @param {number} cate_list_id
 * @return {string}
 */
export const getCateListHref = (cate_list_id) => {
  return `/${TT.lang}/product/list/${cate_list_id}`;
};
